<template>
<div>
  <div class="section">
    <div class="container">
      <!-- Page Header -->
      <div class="mb-md">
        <div class="columns is-vcentered">
          <div class="column is-one-third">
            <breadcrumbs :history="[{ label: 'Settings', name: 'settings'}]" current="Currency Settings" />
          </div>
          <div class="column is-one-third">
            <h1 class="has-text-centered is-size-4">Currency Settings</h1>
          </div>
        </div>
      </div>
      <!-- Preferences -->
      <div class="columns">
        <div class="column is-one-fifth">
          <p class="has-text-weight-bold is-size-6 mb-sm">Currency Settings</p>
          <p class="has-text-grey is-size-7">
            These settings will be used to apply locale-specific configurations (e.g. cost &amp; price on products, etc).
          </p>
        </div>
        <div class="column">
          <!-- Preferences -->
          <div v-if="!loading && preferences.length > 0">
            <div class="mb-lg">
              <CurrencyPreference :preferences="preferences" />
            </div>
          </div>
          <!-- Loading -->
          <div v-else>
            <div class="has-background-white rounded-lg pa-lg mb-lg">
              <b-skeleton />
              <b-skeleton width="50%" />
              <b-skeleton width="25%" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import CurrencyPreference from '../components/Transaction/CurrencyPreference'

export default {
  components: {
    CurrencyPreference
  },
  computed: {
    ...mapGetters(['api', 'context'])
  },
  data () {
    return {
      loading: true,
      preferences: []
    }
  },
  methods: {
    load () {
      this.loading = true
      const endpoint = this.context.route + '/preferences/'
      const query = {
        params: {
          grouping: 'locale'
        }
      }
      this.$http.get(endpoint, query).then(response => {
        this.preferences = response.data.results
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mixins: [],
  mounted () {
    this.load()
  }
}
</script>
